<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Input/NewDInputEditor'
export default {
  name: 'NewDOutsideLinkEditor',
  extends: compoment
}
</script>
